export default "__VITE_ASSET__rNJaONN9__"